// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1RyDb","alertIcon":"ConfirmModal_alertIcon__3gNWf"};